/**
 * USSEDU Main Application
 * Complete AI-powered education platform with 4 user interfaces
 */
import { ConfigProvider } from 'antd';
import { AuthProvider } from './contexts/AuthContext';
import AppRouter from './Router';
import './App.css';

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#faad14', // Sunrise Yellow
          colorInfo: '#faad14',
          colorSuccess: '#52c41a',
          colorWarning: '#faad14',
          colorError: '#ff4d4f',
          borderRadius: 6,
          fontSize: 14,
        },
      }}
    >
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
